export const scroll = {
  "v": "5.9.6",
  "fr": 60,
  "ip": 0,
  "op": 120,
  "w": 750,
  "h": 750,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            375,
            375,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            559.012,
            492.222,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.24,
                      "y": 1
                    },
                    "o": {
                      "x": 0.76,
                      "y": 0
                    },
                    "t": 6,
                    "s": [
                      {
                        "i": [
                          [
                            111.722,
                            -56.131
                          ],
                          [
                            -0.541,
                            56.131
                          ],
                          [
                            -111.722,
                            -55.05
                          ]
                        ],
                        "o": [
                          [
                            111.722,
                            -56.131
                          ],
                          [
                            -0.541,
                            56.131
                          ],
                          [
                            -111.722,
                            -55.05
                          ]
                        ],
                        "v": [
                          [
                            111.722,
                            -56.131
                          ],
                          [
                            -0.541,
                            56.131
                          ],
                          [
                            -111.722,
                            -55.05
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.24,
                      "y": 1
                    },
                    "o": {
                      "x": 0.76,
                      "y": 0
                    },
                    "t": 26.02,
                    "s": [
                      {
                        "i": [
                          [
                            196.498,
                            -21.936
                          ],
                          [
                            7.84,
                            166.722
                          ],
                          [
                            -179,
                            -20.118
                          ]
                        ],
                        "o": [
                          [
                            196.498,
                            -21.936
                          ],
                          [
                            7.84,
                            166.722
                          ],
                          [
                            -179,
                            -20.118
                          ]
                        ],
                        "v": [
                          [
                            196.498,
                            -21.936
                          ],
                          [
                            7.84,
                            166.722
                          ],
                          [
                            -179,
                            -20.118
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 46.041015625,
                    "s": [
                      {
                        "i": [
                          [
                            111.722,
                            -56.131
                          ],
                          [
                            -0.541,
                            56.131
                          ],
                          [
                            -111.722,
                            -55.05
                          ]
                        ],
                        "o": [
                          [
                            111.722,
                            -56.131
                          ],
                          [
                            -0.541,
                            56.131
                          ],
                          [
                            -111.722,
                            -55.05
                          ]
                        ],
                        "v": [
                          [
                            111.722,
                            -56.131
                          ],
                          [
                            -0.541,
                            56.131
                          ],
                          [
                            -111.722,
                            -55.05
                          ]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  559.012,
                  619.737
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.24,
                      "y": 1
                    },
                    "o": {
                      "x": 0.76,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            111.722,
                            56.131
                          ],
                          [
                            -0.541,
                            -56.131
                          ],
                          [
                            -111.722,
                            55.05
                          ]
                        ],
                        "o": [
                          [
                            111.722,
                            56.131
                          ],
                          [
                            -0.541,
                            -56.131
                          ],
                          [
                            -111.722,
                            55.05
                          ]
                        ],
                        "v": [
                          [
                            111.722,
                            56.131
                          ],
                          [
                            -0.541,
                            -56.131
                          ],
                          [
                            -111.722,
                            55.05
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.24,
                      "y": 1
                    },
                    "o": {
                      "x": 0.76,
                      "y": 0
                    },
                    "t": 20.02,
                    "s": [
                      {
                        "i": [
                          [
                            196.498,
                            -6.827
                          ],
                          [
                            7.84,
                            -195.485
                          ],
                          [
                            -179,
                            -8.645
                          ]
                        ],
                        "o": [
                          [
                            196.498,
                            -6.827
                          ],
                          [
                            7.84,
                            -195.485
                          ],
                          [
                            -179,
                            -8.645
                          ]
                        ],
                        "v": [
                          [
                            196.498,
                            -6.827
                          ],
                          [
                            7.84,
                            -195.485
                          ],
                          [
                            -179,
                            -8.645
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 40.041015625,
                    "s": [
                      {
                        "i": [
                          [
                            111.722,
                            56.131
                          ],
                          [
                            -0.541,
                            -56.131
                          ],
                          [
                            -111.722,
                            55.05
                          ]
                        ],
                        "o": [
                          [
                            111.722,
                            56.131
                          ],
                          [
                            -0.541,
                            -56.131
                          ],
                          [
                            -111.722,
                            55.05
                          ]
                        ],
                        "v": [
                          [
                            111.722,
                            56.131
                          ],
                          [
                            -0.541,
                            -56.131
                          ],
                          [
                            -111.722,
                            55.05
                          ]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  559.012,
                  364.708
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 120.12012012012,
      "st": 0,
      "ct": 1,
      "bm": 0,
      "completed": true
    }
  ],
  "markers": [],
  "__complete": true
}